export enum AugloopRealTimeTranscriptionConnectionKeys {
    OffsetAdjustmentMs = "OffsetAdjustmentMs",
    OnError = "OnError",
    OnFinalResult = "OnFinalResult",
    OnPartialResult = "OnPartialResult",
    OnSpeechEnd = "OnSpeechEnd",
    OnSpeechRecognitionStarted = "OnSpeechRecognitionStarted",
    OnSpeechSessionStarted = "OnSpeechSessionStarted",
    MaxSpeakerId = "MaxSpeakerId",
    IsDiarizationEnabled = "IsDiarizationEnabled",
    AudioDecodingTimeMs = "AudioDecodingTimeMs",
    SpeechSessionId = "SpeechSessionId",
    ReceivedNearRTResult = "ReceivedNearRTResult",
    TelemetryDiagnostics = "TelemetryDiagnostics"
};